import { parseInventoryMoney } from './inventoryInputs';
import { calculateMarginPercent } from './margin';

export const incomingItemMargin = (sellingPrice, purchasePrice) => {
  const sale = parseInventoryMoney(sellingPrice);
  const cost = parseInventoryMoney(purchasePrice);
  if (sale == null || sale <= 0 || cost == null) return null;
  const amount = Math.round((sale - cost) * 100) / 100;
  return { amount, percent: calculateMarginPercent(sale - cost, sale) };
};
